import { createSelector, MemoizedSelector } from '@ngrx/store';
import { CustomPointOfService } from '@shop/const';
import { StateUtils } from '@spartacus/core';
import { StateWithCity } from '../city-state';
import { getCityState } from './feature.selector';

export const getBaseStoreShopsState: MemoizedSelector<
  StateWithCity,
  StateUtils.EntityLoaderState<CustomPointOfService[]>
> = createSelector(getCityState, (state) => state.baseStoreShops);

export const getBaseStoreShopsEntityState = (
  code: string,
): MemoizedSelector<StateWithCity, StateUtils.LoaderState<CustomPointOfService[]>> =>
  createSelector(getBaseStoreShopsState, (state) => StateUtils.entityLoaderStateSelector(state, code));
